import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TslSessionService {
  private readonly isSignedInRelay = new BehaviorSubject<boolean>(
    sessionStorage.getItem('accessToken') !== null
  );

  construct(accessToken: string, refreshToken: string): void {
    sessionStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('refreshToken', refreshToken);
    this.isSignedInRelay.next(true);
  }

  destroy(): void {
    this.isSignedInRelay.next(false);
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
  }

  get accessToken(): string {
    return sessionStorage.getItem('accessToken');
  }

  get refreshToken(): string {
    return sessionStorage.getItem('refreshToken');
  }

  get isSignedIn(): boolean {
    return this.isSignedInRelay.getValue();
  }

  get isSignedInObservable(): Observable<boolean> {
    return this.isSignedInRelay.asObservable();
  }
}
